import styles from './Subscription.module.css';
import { useNavigate } from 'react-router-dom';
import CardRegister from 'components/SubscriptionComponents/CardRegister/CardRegister';
import Accordion from 'components/SubscriptionComponents/Accordion/Accordion';
import logoSvg from 'assets/images/logo.svg';
import { useSubscriptionLogic } from './useSubscriptionLogic';
import { MdCheck, MdClose, MdInfo, MdPayment } from 'react-icons/md';
import {
  Breadcrumbs,
  Tooltip,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import PaymentHistory from './PaymentHistory/PaymentHistory';
import { useTranslation } from 'react-i18next';

const Subscription = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { shopTier, shopId, manualPayment, setPaymentOpen, paymentOpen } = useSubscriptionLogic();
  const user = useSelector((state) => state.nonPersistedReducers?.userSliceReducer?.currentUser);
  const [dateInfo, setDateInfo] = useState('');
  const checkDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dueDate = new Date(
      user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData?.length - 1]?.dueDate?.substring(0, 10)
    );
    dueDate.setHours(0, 0, 0, 0);
    if (today === dueDate) {
      return setDateInfo('today');
    } else if (today > dueDate) {
      return setDateInfo('expired');
    } else {
      setDateInfo('');
    }
  };

  useEffect(() => {
    checkDate();
  }, [user]);

  return (
    <div className={styles.mainContainer}>
      <Breadcrumbs aria-label='breadcrumb' className={styles.breadcrumb}>
        <Typography style={{ fontFamily: 'var(--font-main)' }} variant='body1'>
          {t('subscription.title')}
        </Typography>
      </Breadcrumbs>
      <div className={styles.middleContainer}>
        <div className={styles.middleLeft}>
          <h2>{t('subscription.cardRegistration')}</h2>
          <CardRegister />
        </div>
        <div className={styles.middleRight}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>{t('subscription.dataTitle')}</h2>
            {user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData?.length - 1]?.isPaid === false && (
              <Tooltip title={t('subscription.manualPayment')}>
                <Button
                  variant='outlined'
                  sx={{
                    width: '150px !important',
                    fontSize: '11px !important',
                    height: '40px !important',
                    color: 'black !important',
                    borderColor: 'black !important',
                    padding: '0.2rem !important'
                  }}
                  onClick={() => setPaymentOpen(true)}>
                  <span style={{ marginRight: '5px' }}>{t('subscription.manualPayment')}</span>
                  <MdPayment color='black' size={30} />
                </Button>
              </Tooltip>
            )}
          </div>

          {shopTier ? (
            <div className={styles.rightBottom}>
              <div className={styles.subscriptionInfoContainer}>
                <div className={styles.subscriptionInfo}>
                  {t('subscription.startDate')}:{' '}
                  {user?.ownedShops[0]?.historyList?.length > 0
                    ? user?.ownedShops[0]?.historyList[
                        user?.ownedShops[0]?.historyList.length - 1
                      ]?.createdAt?.substring(0, 10)
                    : t('subscription.noData')}
                </div>
                <PaymentHistory paymentData={user?.ownedShops[0]?.paymentData} />
              </div>
              <div className={styles.logoContainer}>
                <img src={logoSvg} alt='logo' />
              </div>
              <h3 className={styles.title}>{t(`subscription.bundles.${shopTier?.name}`)}</h3>
              <div style={{ marginTop: 'auto' }}>
                {t('subscription.nextPaymentDate')}:{' '}
                {shopTier?.commissionRate > 0 && shopTier?.recurringPrice === 0 ? (
                  t('subscription.noAutomaticPayment')
                ) : shopTier?.commissionRate === 0 && shopTier?.recurringPrice === 0 ? (
                  t('subscription.freePackage')
                ) : user?.ownedShops[0]?.paymentData?.length > 0 ? (
                  dateInfo === 'expired' ? (
                    <span style={{ color: 'red' }}>
                      {user?.ownedShops[0]?.paymentData[
                        user?.ownedShops[0]?.paymentData.length - 1
                      ]?.dueDate?.substring(0, 10)}{' '}
                      - {t('subscription.expiredPayment')}
                    </span>
                  ) : dateInfo === 'today' ? (
                    <span style={{ color: 'var(--primary-warning)' }}>
                      {user?.ownedShops[0]?.paymentData[
                        user?.ownedShops[0]?.paymentData.length - 1
                      ]?.dueDate?.substring(0, 10)}{' '}
                      - {t('subscription.todayPayment')}
                    </span>
                  ) : (
                    <span>
                      {user?.ownedShops[0]?.paymentData[
                        user?.ownedShops[0]?.paymentData.length - 1
                      ]?.dueDate?.substring(0, 10)}
                    </span>
                  )
                ) : (
                  t('subscription.noData')
                )}
                <br />
                {shopTier?.commissionRate === 0 &&
                  shopTier?.recurringPrice > 0 &&
                  user?.ownedShops[0]?.paymentData?.length > 0 && (
                    <Tooltip title={t('subscription.packageChange')}>
                      {' '}
                      <>
                        {` ${t('subscription.amount')}: ${
                          user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData?.length - 1]?.totalAmount
                        } ${t('common.currency.symbol')}`}{' '}
                        <MdInfo />
                      </>
                    </Tooltip>
                  )}
                {/* {shopTier?.commissionRate === 0 && shopTier?.recurringPrice === 0 && '-'} */}
              </div>
              <Accordion title={t('subscription.packageDetails')}>
                <div className={styles.details}>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.galleryLimit')}:</p> <p>{shopTier?.galleryLimit}db</p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.productLimit')}:</p> <p>{shopTier?.productsLimit}db</p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.galleryCreation')}:</p>{' '}
                    <p>
                      <MdCheck color='green' fontSize={22} />
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.photoUpload')}:</p>{' '}
                    <p>
                      <MdCheck color='green' fontSize={22} />
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.ownProductDefinition')}:</p>{' '}
                    <p>
                      <MdCheck color='green' fontSize={22} />
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.reports')}:</p>{' '}
                    <p>
                      {shopTier?.reports ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.printOption')}:</p>{' '}
                    <p>
                      {shopTier?.printOption ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.orderDeadline')}:</p>{' '}
                    <p>
                      {shopTier?.galleryExpiryDate ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.orderDeadlineInheritance')}:</p>{' '}
                    <p>
                      {shopTier?.expiryDateInheritance ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.priceInheritance')}:</p>{' '}
                    <p>
                      {shopTier?.priceInheritance ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.automaticGroupGallery')}:</p>{' '}
                    <p>
                      {shopTier?.groupGallery ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.galleryCoding')}:</p>{' '}
                    <p>
                      {shopTier?.galleryCoding ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.onlinePayment')}:</p>{' '}
                    <p>
                      {shopTier?.onlinePayment ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.pricingTemplate')}:</p>{' '}
                    <p>
                      {shopTier?.pricingTemplates ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <div className={styles.detail_item}>
                    <p>{t('subscription.automaticInvoice')}:</p>{' '}
                    <p>
                      {shopTier?.automaticInvoice ? (
                        <MdCheck color='green' fontSize={22} />
                      ) : (
                        <MdClose color='red' fontSize={22} />
                      )}
                    </p>
                  </div>
                  <b>{t('subscription.packagePrice')}:</b>{' '}
                  {shopTier?.recurringPrice
                    ? user?.ownedShops[0]?.historyList?.length > 0 &&
                      user?.ownedShops[0]?.historyList[user?.ownedShops[0]?.historyList?.length - 1]?.yearlyPricing
                      ? `${shopTier?.recurringPriceYearly} ${t('common.currency.perYear')}`
                      : `${shopTier?.recurringPrice} ${t('common.currency.perMonth')}`
                    : `${t('subscription.commissionRate')} ${shopTier?.commissionRate * 100}%`}
                </div>
              </Accordion>
            </div>
          ) : (
            <div className={styles.rightBottom}>
              <div className={styles.subscriptionInfo}>{t('subscription.noSubscription')}</div>
              <h3 className={styles.title}>{t('subscription.noSubscription')}</h3>
              <Button
                className={styles.buttonDark}
                style={{ marginBottom: '1.1rem' }}
                onClick={() => {
                  navigate(`/shops/${shopId}/administration/subscriptions-bundles`);
                }}>
                {t('subscription.buyBundles')}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className={styles.bottom}>
        <h2 className={styles.bundles_title}>{t('subscription.showBundles')}</h2>
        <Button
          className={styles.buttonDark}
          onClick={() => {
            navigate(`/shops/${shopId}/administration/subscriptions-bundles`);
          }}>
          {t('subscription.bundles.title')}
        </Button>
      </div>

      <Dialog open={paymentOpen} onClose={() => setPaymentOpen(false)}>
        <DialogTitle>{t('subscription.manualPaymentTitle')}</DialogTitle>
        <DialogContent>
          <p>
            <b>{t('subscription.currentAmount')}:</b>{' '}
            {user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData.length - 1]?.totalAmount}{' '}
            {t('common.currency.symbol')}
            <br />
            <b>{t('subscription.paymentDueDate')}:</b>{' '}
            {dateInfo === 'expired' ? (
              <span style={{ color: 'red' }}>
                {user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData.length - 1]?.dueDate?.substring(
                  0,
                  10
                )}{' '}
                - {t('subscription.expiredPayment')}
              </span>
            ) : dateInfo === 'today' ? (
              <span style={{ color: 'var(--primary-warning)' }}>
                {user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData.length - 1]?.dueDate?.substring(
                  0,
                  10
                )}{' '}
                - {t('subscription.todayPayment')}
              </span>
            ) : (
              <span>
                {user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData.length - 1]?.dueDate?.substring(
                  0,
                  10
                )}
              </span>
            )}
          </p>
          <p>
            {t('subscription.manualPaymentDescription')} <br />
            <br />
            <b> {t('subscription.manualPaymentDescription2')}</b>
          </p>
        </DialogContent>
        <DialogActions>
          <div className={styles.button_wrapper}>
            <button className={styles.cancel_button} onClick={() => setPaymentOpen(false)}>
              {t('common.cancel')}
            </button>

            <button
              disabled={manualPayment?.isLoading}
              className={styles.submit_button}
              onClick={() => manualPayment.mutate()}>
              {manualPayment?.isLoading ? (
                <CircularProgress style={{ color: 'black' }} size={20} />
              ) : (
                t('subscription.pay')
              )}
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Subscription;
